var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoginPageTravelIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svgexport-6",
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.703,
    height: 43.702,
    viewBox: "0 0 43.703 43.702",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3935",
    "data-name": "Path 3935",
    d: "M94.86,181.77a.854.854,0,1,0-.6.25A.86.86,0,0,0,94.86,181.77Zm0,0",
    transform: "translate(-85.43 -164.922)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3936",
    "data-name": "Path 3936",
    d: "M4.593,441.367.25,445.71a.853.853,0,1,0,1.207,1.207L5.8,442.574a.853.853,0,1,0-1.207-1.207Zm0,0",
    transform: "translate(0 -403.465)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3937",
    "data-name": "Path 3937",
    d: "M.854,228.568a.85.85,0,0,0,.6-.25l4.772-4.772a.854.854,0,1,0-1.207-1.207L.25,227.11a.854.854,0,0,0,.6,1.457Zm0,0",
    transform: "translate(0 -203.132)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3938",
    "data-name": "Path 3938",
    d: "M224.006,467.781l-2.088,2.088a.853.853,0,1,0,1.207,1.207l2.088-2.088a.854.854,0,0,0-1.207-1.207Zm0,0",
    transform: "translate(-202.747 -427.624)",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3939",
    "data-name": "Path 3939",
    d: "M43.285,23.18l-9.443-5.611,6.4-6.4A11.853,11.853,0,0,0,43.542.863a.853.853,0,0,0-.7-.7,11.852,11.852,0,0,0-10.312,3.3L26.488,9.5l-2.742-.261a2.621,2.621,0,0,0-4.352-2.649L17.355,8.634,14.65,8.376A2.622,2.622,0,0,0,10.306,5.7L8.24,7.764l-3.5-.334a.855.855,0,0,0-.685.246L.25,11.483a.854.854,0,0,0,.209,1.36L5.4,15.421a.853.853,0,0,0,.789-1.513l-3.91-2.04,2.7-2.7,19.943,1.9-8.285,8.285-4.372-2.28a.854.854,0,0,0-.79,1.514l3.9,2.032-1.341,1.34a25.5,25.5,0,0,0-3.5,4.36l-7.424.137a.854.854,0,0,0-.588.25L.538,28.692A.854.854,0,0,0,.869,30.1l6.855,2.311a25.633,25.633,0,0,0-.792,3.374.854.854,0,0,0,.981.981,25.632,25.632,0,0,0,3.374-.792L13.6,42.834a.853.853,0,0,0,1.412.331l1.985-1.984a.854.854,0,0,0,.25-.588l.129-7.418a25.414,25.414,0,0,0,3.75-2.906A16.107,16.107,0,0,0,32.088,43.659a.854.854,0,0,0,.535,0A16.111,16.111,0,0,0,43.7,28.334V23.914a.853.853,0,0,0-.417-.734ZM20.6,7.8a.914.914,0,0,1,1.317,1.267l-2.36-.225Zm-9.088-.9A.915.915,0,1,1,12.807,8.2h0l-2.362-.225Zm-8.8,22.021.768-.768,6.046-.111A25.109,25.109,0,0,0,8.281,30.8Zm12.826,11.29-.768.768L12.9,35.421a25.082,25.082,0,0,0,2.749-1.247Zm.583-8.278a.8.8,0,0,0-.074.045,23.518,23.518,0,0,1-7.2,2.87,23.528,23.528,0,0,1,6.39-11.685l18.5-18.5a10.145,10.145,0,0,1,8.206-2.91,10.145,10.145,0,0,1-2.91,8.206l-6.885,6.885a.855.855,0,0,0-.226.093L21.426,23.18a.854.854,0,0,0-.418.734v4.075l-.475.475a23.745,23.745,0,0,1-4.407,3.474ZM42,28.334a14.405,14.405,0,0,1-9.64,13.613,14.405,14.405,0,0,1-9.639-13.534.852.852,0,0,0,0-.16V24.4l9.64-5.728L42,24.4Zm0,0",
    transform: "translate(0 0)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3940",
    "data-name": "Path 3940",
    d: "M293.622,243.76l-7.079,4.206a.854.854,0,0,0-.418.734v2.478a12.72,12.72,0,0,0,7.589,11.643.853.853,0,0,0,.688,0,12.719,12.719,0,0,0,7.589-11.643V248.7a.854.854,0,0,0-.417-.734l-7.079-4.206a.853.853,0,0,0-.872,0Zm6.661,5.426v1.992a11.013,11.013,0,0,1-6.226,9.922,11.014,11.014,0,0,1-6.226-9.922v-1.992l6.226-3.7Zm0,0",
    transform: "translate(-261.702 -222.843)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3941",
    "data-name": "Path 3941",
    d: "M351.125,325.319a.854.854,0,0,0-1.207,1.207l1.39,1.39a.854.854,0,0,0,1.207,0l3.382-3.382a.854.854,0,1,0-1.207-1.207l-2.779,2.779Zm0,0",
    transform: "translate(-319.821 -295.501)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3942",
    "data-name": "Path 3942",
    d: "M337.971,73.121a.851.851,0,0,0,.6-.25l7.788-7.789a.853.853,0,1,0-1.207-1.207l-7.789,7.788a.854.854,0,0,0,.6,1.457Zm0,0",
    transform: "translate(-308.342 -58.194)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3943",
    "data-name": "Path 3943",
    d: "M309.686,184.867a.854.854,0,1,0-.6-.25A.864.864,0,0,0,309.686,184.867Zm0,0",
    transform: "translate(-282.471 -167.526)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginPageTravelIcon);
export default __webpack_public_path__ + "static/media/login-page-travel-icon.337b54dfeae596cc8d90ffd237bf4812.svg";
export { ForwardRef as ReactComponent };